import style from "@/styles/pages/ForgotPassword/ForgotPassword.module.css";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { createApiClient } from "@/lib/Requests";
import FadeTransition from "@/styles/animation/FadeTransition";
import { useForm } from "react-hook-form";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { setSingleClickInsightEvent } from "@/lib/util";

export default function ForgotPassword() {
    const client = createApiClient({ timeout: 60000 });
    const [resetInProgress, setResetInProgress] = useState(false);

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(-1)
    }

    const methods = useForm({
        defaultValues: {
            email: "",
        },
    });

    const onError = (errors: object) => {

    }

    const onSubmit = (data: any) => {
        setResetInProgress(true);
        client.apiAuthForgotpassword(data.email).then((result) => {

            console.log(result)
            setResetInProgress(false);
            navigate("/password-reset-requested", { state: { email: data.email } });

        }).catch((error) => {
            setResetInProgress(false);
            console.log("Error creating password reset request", error);
            if (error && error.response) {
                methods.setError("email", {
                    type: "account",
                    message: error.response.message,
                });
            }
        });
    };

    useEffect(() => {
        setSingleClickInsightEvent("login", "reset password");
    }, []);

    return (
        <FadeTransition>
            <main aria-labelledby="main-content">
                <div className="main-container max-md:mt-10">
                    <div className={clsx(style.login, "container", "mt-10")}>
                        <div className={style.emHeading}>
                            <div className="grid grid-cols-1">
                                <h1>Forgot your password?</h1>
                                <div className="max-sm:hidden">
                                    <p>To reset your password please use the method below</p>
                                    <p>that applies to you.</p>
                                </div>
                                <div className="sm:hidden">
                                    <p>To reset your password please use the method below that applies to you.</p>
                                </div>

                            </div>
                        </div>
                        <div className={style.resetInstructions}>
                            <h3 className="brand-blue-text" style={{ fontSize: 16 }}>For Existing Members</h3>
                            <p>You can reset your online banking password with the self-serve tool using the link below.</p>
                            <a href="https://banking.meridiancu.ca/ForgotPassword_Setup" target="_blank">
                                <div style={{ textAlign: 'end' }} className="active flex flex-wrap flex-row">
                                    <span>Reset Your Password</span>
                                    <img
                                        src="assets/arrow-forward.svg"
                                        className={clsx(
                                            "w-5 h-6 top-6 ml-2"
                                        )}
                                        alt="error"
                                    />
                                </div>
                            </a>
                        </div>
                        <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
                            <div className={style.resetInstructions}>
                                <h3 className="brand-blue-text" style={{ fontSize: 16 }}>Returning applicants (non-members)</h3>
                                <div className="flex flex-wrap">
                                    <p>Enter the email address used during your application and we’ll send you a link to reset your password.</p>
                                </div>
                                <div className="mt-5">
                                    <label htmlFor="email">Email Address</label>
                                    <div className="flex relative">
                                        <span>
                                            <img
                                                src="assets/error-icon.svg"
                                                className={clsx(
                                                    methods.formState?.errors?.email ? "" : "hidden",
                                                    "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[400px]"
                                                )}
                                                alt="error"
                                                height={5}
                                                width={5}
                                            />
                                        </span>
                                        <input
                                            className={clsx("mt-2")}
                                            type="email"
                                            id="email"
                                            autoComplete="email"
                                            style={{ width: '-webkit-fill-available' }}
                                            {...methods.register("email", {
                                                required: "Enter your email address",
                                            })}
                                        />
                                    </div>
                                    {methods.formState?.errors?.email?.message && (
                                        <span className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                            {methods.formState.errors.email.message}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="flex relative">
                                <button
                                    type="submit"
                                    disabled={resetInProgress}
                                    className={clsx(
                                        "primary mt-5 w-full sm:w-28 h-11 px-6",
                                        resetInProgress ? style.loginDisabled : ""
                                    )}
                                >
                                    <FontAwesomeIcon
                                        icon={faSpinner}
                                        spin
                                        style={{ marginRight: 8 }}
                                        className={clsx(resetInProgress ? "" : "hidden")}
                                    />
                                    Continue
                                </button>
                            </div>
                        </form>

                        <div className="relative mt-5">
                            <div className="active text-center flex justify-center" onClick={handleClick}>
                                <img
                                    src="assets/arrow-back.svg"
                                    className={clsx(
                                        "w-5 h-6 top-6"
                                    )}
                                    alt="error"
                                />
                                <span className="ml-2 cursor-pointer">Back to Login</span>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </FadeTransition>
    );
}